var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nested-menu",staticStyle:{"display":"none"},attrs:{"id":"editProcedureMenu"}},[_c('nested-draggable-menu',{ref:"nestedMenu",staticStyle:{"position":"fixed","margin-top":"30px","right":"68px","z-index":"1002"},attrs:{"isroot":true,"parentexpanded":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e361ec2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/procedure/procedure-editmenu.vue
// module id = 1203
// module chunks = 0